import apiCall from "../../utils/api";
import { DOMAINS_SELECT, DOMAINS_SUCCESS} from "../actions/domains";
import {APP_STATE_ERROR, APP_STATE_REQUEST, APP_STATE_SUCCESS} from "../actions/app";
import {USER_SUCCESS} from "../actions/user";

const state = {
    status: '',
    server: '',
};
const actions = {

    [APP_STATE_REQUEST]: ({commit, dispatch}) => {
        commit(APP_STATE_REQUEST);
        apiCall({url: 'app/state', 'method': 'get'})
            .then(resp => {
                let domains = resp.domains;
                let user = resp.user;

                commit(USER_SUCCESS, user);
                commit(DOMAINS_SUCCESS, domains);
                commit(APP_STATE_SUCCESS, resp.server);

                dispatch(DOMAINS_SELECT);
            })
            .catch(error => {
                console.log('Error', error);
                commit(APP_STATE_ERROR);
            });
    }

};

const mutations = {
    [APP_STATE_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [APP_STATE_SUCCESS]: (state, server) => {
        state.status = 'success';
        state.server = server;
    },
    [APP_STATE_ERROR]: (state) => {
        state.status = 'error';
    }
};

export default {
    state,
    actions,
    mutations,
}